export default __webpack_public_path__ + "static/media/logoWithTextAr.d8221edb.svg";